<template>
  <div class="SimpleSaleDetailViewContainer">
    <!--主图-->
    <img :src="detail.coverImage" style="width: 100%"/>

    <nut-row class="colFlex pd16 wd100 box">
      <span class="ft18 boldFont" style="color: #36404a">{{ detail.name }}</span>
      <span class="ft14 mt10" style="color: #8d9dad">{{ detail.subTitle }}</span>
      <nut-row class="leftCenter mt12">
        <span class="numberText">¥&nbsp;</span>
        <span class="numberText ft24 boldFont">{{ (minPriceSku(detail.skus).price / 100.0).toFixed(2) }}</span>
        <span class="ml12 ft16"
              style="color: #8d9dad;text-decoration: line-through">¥{{ (minPriceSku(detail.skus).originalPrice / 100.0).toFixed(2) }}</span>
        <span class="ml12 ft16" style="color: #8d9dad;">已售{{ detail.fakeBuyerCnt + detail.realBuyerCnt }}</span>
      </nut-row>
    </nut-row>
    <template v-for="(ipt,iptIndex) in detail.introduceParts" :key="`introduceParts${iptIndex}`">
      <template v-if="iptIndex<1">
        <template v-for="p in ipt.contents" :key="`pppp_${p.id}`">
          <template v-if="p.contentType =='VIDEO'">
            <div class="colFlex bothCenter" style="position:relative;" @click="playVideo(p.content)">
              <img :src="`${p.content}?x-oss-process=video/snapshot,t_5000`"
                   @click="playVideo(p.content)"
                   style="width: 100%" class="wd100"/>
              <img src="https://cdn.waityou.online/19d94b56-8c5e-6a6c-0e5a-a5156332e4dd.svg"
                   class="sqr80 wbg brd80"
                   @click="playVideo(p.content)"
                   style="position: absolute;top: calc(50% - 40px);left: calc(50% - 40px)">
            </div>
          </template>
          <img :src="p.content" style="margin-top: 8px;padding: 0;vertical-align: middle;"
               class="wd100" v-if="p.contentType =='IMG'"/>
          <!--          <p class="pd8 box ft16" style="margin: 0" v-if="p.contentType =='TEXT'" v-html="p.content"></p>-->
          <div class="opd8" style="margin: 0" v-if="p.contentType =='TEXT'" v-html="p.content"></div>

        </template>
        <!--        <img v-for="img in ipt.images" :key="`${iptIndex}_${img}`" :src="img"-->
        <!--             style="margin-top: 0;padding: 0;vertical-align: middle;" class="wd100"/>-->
      </template>
    </template>

    <nut-row class="wd100 wbg" style="position:fixed;bottom: 0;">
      <nut-row class="bothCenter opd16 vpd12 box">
        <button class="wft ft16 buyBtn vpd8 wd100 brd20" @click="buyNow">立即购买</button>
      </nut-row>
    </nut-row>

    <nut-popup position="bottom" v-model:visible="skuVisible" closeable>
      <SkuSelector :skus="detail.skus" v-if="detail" @buySku="buySku"/>
    </nut-popup>
    <nut-popup v-model:visible="playerVisible" lock-scroll
               style="width: 90vw;background: transparent">
      <video :src="videoUrl" style="margin: 8px 0 0 0;padding: 0;" autoplay="autoplay"
             class="wd100" controls v-if="playerVisible"></video>
    </nut-popup>
  </div>
</template>

<script>


import api from "@/api";
import {Toast} from "@nutui/nutui";
import SkuSelector from "@/components/sale/SkuSelector";


export default {
  name: "SimpleSaleDetailView",
  components: {SkuSelector},
  props: {
    detail: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      lessonId: this.$route.params.lessonId,
      orderId: this.$route.query.orderId,
      orderQueryCnt: 3,
      skuVisible: false,
      playerVisible: false,
      videoUrl: null,
    }
  },
  methods: {
    playVideo(url){
      this.videoUrl = url;
      this.playerVisible = true;
    },
    minPriceSku(skus) {
      let m = null;
      for (let s of skus) {
        if (m == null || s.originalPrice < m.originalPrice) {
          m = s;
        }
      }
      return m;
    },
    init() {
      if (this.orderId) {
        Toast.loading('正在查询支付结果...')
        this.queryPayOrder();
      }
      this.$emit('showHelp')
    },
    queryPayOrder() {
      api.getSaleOrder(this.orderId)
          .then(ret => {
            if (!ret.paid) {
              if (this.orderQueryCnt-- <= 0) {
                Toast.fail('支付失败!')
                return
              }
              Toast.loading('正在查询支付结果...')
              setTimeout(this.queryPayOrder, 1000)
              return
            }
            Toast.success('支付成功')
            this.afterPaid();
          })
    },
    afterPaid() {
      this.$router.replace('/sale/fill/info/' + this.orderId)
    },
    buyNow() {
      if (this.detail.skus.length > 1) {
        //多sku
        this.skuVisible = true;
      } else {
        this.buySku(this.detail.skus[0])
      }
    },
    buySku(sku) {
      this.$router.push(`/sale/create/${this.lessonId}/${sku.id}`)
      // // Toast.loading('正在发起支付...')
      // let host = window.location.protocol + '//' + window.location.host
      // console.log('host', host)
      // api.createPayOrder({
      //   goodId: this.lessonId,
      //   skuId: sku.id,
      //   redirect: host + '/d/' + this.lessonId,
      // }).then(ret => {
      //   window.location.href = ret;
      // })
    }
  },
  mounted() {
    this.init()
  },
  unmounted() {

  }
}
</script>
<style>
.nut-noticebar-vertical {
  border-radius: 20px !important;
}
</style>
<style lang="scss" scoped>
.SimpleSaleDetailViewContainer {
  display: flex;
  position: relative;
  flex-direction: column;
  background-color: white;
  min-height: 100vh;
  padding-bottom: 80px;


  .buyBtn {
    border: none;
    background: #fe7b2b;
  }
}
</style>